$(document).ready(function() {
  $('.scrolling').on('click', function (e) {
    e.preventDefault();
    let getID = $(this).attr('href');

    $('html, body').animate({
      scrollTop: $(getID).offset().top-60
    }, 1000);
  });

  $('.menu-open').click(function() {
    $(this).hide();
    $('.menu-close').show();
    $('.header-overlay').show();
    $('.header-main .section-header .menu').addClass('show');
  });

  $('.menu-close, .scrolling, .header-overlay').click(function() {
    $('.menu-close').hide();
    $('.menu-open').show();
    $('.header-overlay').hide();
    $('.header-main .section-header .menu').removeClass('show');
  });
});


document.addEventListener('DOMContentLoaded', function(){ 
  const sections = document.querySelectorAll(".section-scroll");
  const menu_links = document.querySelectorAll(".scrolling");
  
  const makeActive = (link) => menu_links[link].classList.add("active");
  const removeActive = (link) => menu_links[link].classList.remove("active");
  const removeAllActive = () => [...Array(sections.length).keys()].forEach((link) => removeActive(link));
  const sectionMargin = 200;
  let currentActive = 0;

  // listen for scroll events
  window.addEventListener("scroll", () => {
    const current = sections.length - [...sections].reverse().findIndex((section) => window.scrollY >= section.offsetTop - sectionMargin ) - 1
    if (current !== currentActive) {
      removeAllActive();
      currentActive = current;
      makeActive(current);
    }
  });
}, false);

$(document).ready(function() {
  adjustContentHeight();
});

$(window).on('resize', function() {
  adjustContentHeight();
});

/*function adjustContentHeight() {
  var windowHeight = $(window).height();
  var contentHeight = $('.menu.show').outerHeight();
  var navBarHeight = windowHeight - contentHeight;
  $('.menu.show').css('height', `calc(100% - ${navBarHeight}px)`);
}*/


